<div class="follower-container">
    <list-gauge-circle-chart [charts]="channelFollowersData"
                            [titlePosition]="'bottom'"
                            [hasBorderLeft]="false"
                            [isChannelFollower]="true">
    </list-gauge-circle-chart>
</div>


// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/channel-followers/channel-followers.component.html